import { render, staticRenderFns } from "./FastFingersComponent.vue?vue&type=template&id=2e540e74&scoped=true&"
import script from "./FastFingersComponent.vue?vue&type=script&lang=ts&"
export * from "./FastFingersComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FastFingersComponent.vue?vue&type=style&index=0&id=2e540e74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e540e74",
  null
  
)

export default component.exports